import script from "./fleet.cattle.io.gitreporestriction.vue?vue&type=script&setup=true&lang=ts"
export * from "./fleet.cattle.io.gitreporestriction.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__